import receiptService from "@/services/receiptService";

export default {
  namespaced: true,
  state: {
    receipts: [],
    total: 0,
    pendingCount: 0,
    isLoading: false,
  },
  getters: {
    receipts: (state) => state.receipts,
    total: (state) => state.total,
    pendingCount: (state) => state.pendingCount,
    isLoading: (state) => state.isLoading,
  },
  mutations: {
    setReceipts(state, { rows, total }) {
      state.receipts = rows;
      state.total = total;
    },
    setPendingCount(state, count) {
      state.pendingCount = count;
    },
    setLoading(state, status) {
      state.isLoading = status;
    },
  },
  actions: {
    async fetchReceipts({ commit }, params) {
      commit("setLoading", true);
      try {
        const response = await receiptService.list(params);
        const rows = Array.isArray(response.data) ? response.data : (response.data?.data || []);
        commit("setReceipts", {
          rows,
          total: response.total || response.data?.total || rows.length,
        });
      } catch (error) {
        console.error("Failed to fetch receipts", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchPendingCount({ commit }) {
      try {
        const response = await receiptService.list({ status: "pending_approval", limit: 1 });
        const rows = Array.isArray(response.data) ? response.data : (response.data?.data || []);
        commit("setPendingCount", response.total || response.data?.total || rows.length);
      } catch (error) {
        console.error("Failed to fetch pending receipt count", error);
      }
    },
  },
};
